import { RootState } from "../../../../../models";
import { SubscriptionStepData, SubscriptionStepsState } from "../../../../../models/state";

export type State = RootState;

export const getSubscriptionStepsState = (state: State): SubscriptionStepsState | undefined =>
    state.retailer?.subscriptionSteps;

export const getSubscriptionStepData = (state: State, subscriptionId: string): SubscriptionStepData => {
    const stepsState = getSubscriptionStepsState(state);
    return (
        stepsState?.[subscriptionId] || {
            currentStepIndex: 0,
            totalSteps: 4,
            completedSteps: 0,
        }
    );
};

export const getCurrentSubscriptionStep = (state: State, subscriptionId?: string): number =>
    subscriptionId ? getSubscriptionStepData(state, subscriptionId).currentStepIndex : 0;

export const getCompletedSubscriptionSteps = (state: State, subscriptionId?: string): number =>
    subscriptionId ? getSubscriptionStepData(state, subscriptionId).completedSteps : 0;

export const isAddingSubscription = (state: State): boolean => !!getSubscriptionStepsState(state)?.isAddingSubscription;
